import { Grid, WithStyles, withStyles } from "@material-ui/core";
import * as React from "react";

import { getAvailableProductsForMe } from "../../helper/functions.helper";
import { User } from "../../models/User.model";
import Product from "../Product/Product";
import { styles } from "./Products.style";

type ProductProps = {
    user: User;
    push();
};

class Products extends React.Component<ProductProps & WithStyles<typeof styles>> {
    public render() {
        const classes = this.props.classes;
        const products = getAvailableProductsForMe(this.props.user);

        return (
            <Grid container={true} className={classes.container}>
                {products.map((p) => (
                    <Grid key={`${p.name}-${p.variant}`} className={classes.product} item={true}>
                        <Product push={this.props.push} {...p} />
                    </Grid>
                ))}
            </Grid>
        );
    }
}

export default withStyles(styles)(Products);



// WEBPACK FOOTER //
// ./src/components/Products/Products.tsx